/**
 * Whether the vendor has already been offered the onboarding.
 *
 * Kept in localStorage rather than on the vendor record on purpose: refusing
 * to add a website is not a fact about the business, it is a fact about this
 * person on this machine right now. The reminder itself is not lost by
 * skipping — the dashboard's setup-gap card asks for the same website, and it
 * is computed from the profile on the server, so it survives a cleared browser
 * and reappears everywhere until the website is actually filled in.
 *
 * Keyed per vendor so two accounts on one machine do not silence each other.
 */
const KEY = 'ardealy.bo.onboarding.skipped';

const read = (): string[] => {
    try {
        const raw = localStorage.getItem(KEY);
        return raw ? (JSON.parse(raw) as string[]) : [];
    } catch {
        // A private window, or storage the browser refuses. Treat it as "never
        // offered": showing the invitation twice is a smaller harm than never.
        return [];
    }
};

let currentVendor = '';

/** Called once the vendor is known, so the flag can be scoped to them. */
export const setOnboardingVendor = (vendorId?: string) => {
    currentVendor = vendorId || '';
};

export const hasSkippedOnboarding = (vendorId?: string): boolean => {
    const id = vendorId || currentVendor;
    return id ? read().includes(id) : false;
};

export const markOnboardingSkipped = (vendorId?: string) => {
    const id = vendorId || currentVendor;
    if (!id) return;
    try {
        const all = read();
        if (!all.includes(id)) localStorage.setItem(KEY, JSON.stringify([...all, id]));
    } catch {
        /* nothing to do; the invitation simply shows again next time */
    }
};
